import { render, staticRenderFns } from "./CosmoformTemplateCreateDialog.vue?vue&type=template&id=e20b8c20&scoped=true"
import script from "./CosmoformTemplateCreateDialog.vue?vue&type=script&lang=js"
export * from "./CosmoformTemplateCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./CosmoformTemplateCreateDialog.vue?vue&type=style&index=0&id=e20b8c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20b8c20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSkeletonLoader,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep,VTextField})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
